import React, { forwardRef, useRef, useImperativeHandle } from "react";
import styled from "styled-components";
import IEditableProps from "../../utilities/IEditableProps";
import IStyledProps from "../../utilities/IStyledProps";
import classNames from "classnames";
import { VISIBLE_COMPONENTS_NAMES } from '../../context/VisibleComponentsContext';
import { useOnScreen } from '../Hooks/useOnScreen';

export interface IHeroFlexProps extends IEditableProps, IStyledProps {
    children
}

const HeroFlex = forwardRef((props: IHeroFlexProps, ref: any) => {
    const { children, editorClassObj, className, cmsId } = props;

    const innerRef = useRef<HTMLInputElement>(null);

    useOnScreen(innerRef, VISIBLE_COMPONENTS_NAMES.FOOTER);
    useImperativeHandle(ref, () => innerRef.current!, []); // Passes innerRef to forwardRef's ref so that we can use innerRef in custom hook

    return (
        <div data-id={cmsId} ref={innerRef} className={classNames(className, editorClassObj)}>
            {children}
        </div>
    )
});

export default styled(HeroFlex)`
    width: 100%;
    min-height: 10rem; /* to be selectable in buildr cms ui */

    .hero-sub-title {
        font-family: "National2 Narrow";
        font-size: 0.889rem;
        font-weight: 500;
        line-height: 1.556rem;
        letter-spacing: 0.03rem;
    }
`;